import React from "react";
import { useNavigate } from "react-router-dom";

const TicketBooking = () => {

  const navigate = useNavigate();

  return (
    <div>
      <div
        className="relative w-full h-[250px] sm:h-[300px] flex md:items-end md:px-16 md:pb-24 items-center px-6 md:justify-start bg-cover bg-center"
        style={{ backgroundImage: "url('/bg1.png')" }}
      >
        <div className="absolute inset-0 cus-grad"></div>
        <h1 
          className="relative text-xl font-bold text-start text-white cursor-pointer sm:text-4xl"
        >
          BOOK TICKET NOW
        </h1>
      </div>
      
      {/* New Panel */}
      <div className="flex justify-center px-4 mt-6 sm:justify-start md:px-16 ">
        <div className="p-6 text-white bg-[#122553] rounded-lg shadow-lg w-full sm:w-80">
          <div className="flex flex-col items-center space-x-0 text-center  sm:items-start  sm:text-left">
            <img src="/lave.png" alt="Festival Icon" className="h-16 mx-auto sm:h-20 sm:mx-0" />
            <div className="mt-3">
              <h2 className="text-lg font-bold">Festival Entry</h2>
              <p className="text-sm font-semibold">Buy online, starting from AED 10.00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketBooking;
